export const THUMB_SIZE = 54;

export const calculateAspectRatioFit = (
  srcWidth: number,
  srcHeight: number,
  maxWidth: number,
  maxHeight: number,
): { width: number; height: number } => {
  const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
  return { width: srcWidth * ratio, height: srcHeight * ratio };
};

interface BaseProperties {
  width: number;
  height: number;
  url?: string;
}

export interface ImageElementData extends BaseProperties {
  image: HTMLImageElement | HTMLCanvasElement;
}

export interface VideoElementData extends BaseProperties {
  video: HTMLVideoElement;
}
export interface VideoFrameState {
  updatedFrameTime: number;
  video: HTMLVideoElement;
}
export type RegionThumbProps = {
  regionData?: CF.API.ShapeProps;
  className?: string;
  imageData?: ImageElementData | VideoElementData | null;
  id: string;
  frameVideo?: VideoFrameState | undefined | null;
  showRegionIcon?: boolean;
  /** Size of the thumb in pixels. */
  size?: number;
};
